import { useRef } from 'react';
import Link from 'next/link';
import { useToggle } from '@/hooks/useToggle';
import Menu, { MenuItem } from '@/components/Menu';
import { CaretDownIcon } from '@/icons';
import { PLATFORMS } from '../constants';
import { classes } from './utils';

export type PlatformSelectorProps = {
  isStatic?: boolean;
};

export default function PlatformSelector({
  isStatic = false,
}: PlatformSelectorProps) {
  const menuToggleRef = useRef<HTMLDivElement>(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  const renderLabel = () => (
    <span className={classes.label}>
      Unison<sup className={classes.aiMark}>[AI]</sup>
    </span>
  );

  if (isStatic) {
    return <div className={classes.staticWrapper}>{renderLabel()}</div>;
  }

  return (
    <>
      <div ref={menuToggleRef}>
        <div className={classes.wrapper} onClick={() => toggleMenu()}>
          {renderLabel()}
          <CaretDownIcon className={classes.caretIcon} />
        </div>
      </div>
      <Menu
        anchorTo={menuToggleRef.current}
        open={isMenuOpen}
        onClose={() => toggleMenu()}>
        <Link href={PLATFORMS.CRM}>
          <MenuItem label="CRM" />
        </Link>
        <Link href={PLATFORMS.INSIGHTS}>
          <MenuItem label="Insights" />
        </Link>
      </Menu>
    </>
  );
}
